import {BaseApp} from './app';
import {Registry} from './registry';

// make manager a default export
export const appRegistry = new Registry();

export {BaseApp, Registry};
